"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import styles from "./auth.module.scss";
import { authAPI } from "../../api/api";

const Auth = () => {
  const router = useRouter();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Уже авторизован — молча уведём в ЛК. Форму при этом показываем сразу,
  // чтобы зависший me() не блокировал страницу.
  useEffect(() => {
    authAPI
      .me()
      .then((r) => {
        if (r?.data?.authenticated) router.replace("/lk");
      })
      .catch(() => {
        /* 401 = не авторизован, остаёмся на форме */
      });
  }, [router]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setError("");

    const trimmedLogin = login.trim();
    if (!trimmedLogin || !password) {
      setError("Введите логин и пароль");
      return;
    }

    setLoading(true);
    try {
      // Django ставит cookie sessionid — больше ничего сохранять не надо.
      await authAPI.login(trimmedLogin, password);
      router.replace("/lk");
    } catch (err: any) {
      const status = err?.response?.status;
      const serverMsg =
        err?.response?.data?.error || err?.response?.data?.message;
      if (err?.code === "ERR_NETWORK" || !err?.response) {
        setError("Сервер недоступен — проверьте интернет-соединение");
      } else if (status === 401) {
        setError(serverMsg || "Неверный логин или пароль");
      } else if (status === 403) {
        setError(serverMsg || "Учётная запись деактивирована");
      } else {
        setError(serverMsg || `Ошибка авторизации (HTTP ${status ?? "?"})`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authCard}>
        <div className={styles.header}>
          <img src="/logo.svg" alt="Экобит" className={styles.logo} />
          <h1>Авторизация Экобит</h1>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <input
              type="text"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className={styles.input}
              required
              disabled={loading}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className={styles.inputGroup}>
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button
            type="submit"
            className={`${styles.button} ${loading ? styles.loading : ""}`}
            disabled={loading}
          >
            {loading ? "Вход..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;
